export default __webpack_public_path__ + "static/media/courseOnlineIcon.b581d867.svg";